import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
};

export const updateCampaignInternalSubscription = createAsyncThunk(
  'campaign/update-internal-subscription',
  async ({ id, data, onSuccess }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/campaign/update-internal-subscription/${id}`, data);
      response?.data?.message && notification.success({ message: 'Success', description: response?.data?.message });
      onSuccess && onSuccess();
      return response?.data;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.errors[0]?.message || 'Network error',
      });
      return rejectWithValue(error?.response?.data);
    }
  }
);

const updateCampaignInternalSubscriptionSlice = createSlice({
  name: 'Update Campaign Subscription',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateCampaignInternalSubscription.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
    });
    builder.addCase(updateCampaignInternalSubscription.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action?.payload?.success;
      state.message = action?.payload?.message;
    });
    builder.addCase(updateCampaignInternalSubscription.rejected, (state, action) => {
      state.isLoading = false;
      state.sessionUrl = '';
      state.errors = action.payload?.errors || [];
      state.isError = true;
    });
  },
});

export default updateCampaignInternalSubscriptionSlice?.reducer;
